import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AccessToken } from '@okta/okta-auth-js';
import { Observable, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService } from '../../core/services/auth';

export const DynamicAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const oktaAuth = inject(OKTA_AUTH);
  const authService = inject(AuthService);

  return from(oktaAuth.tokenManager.get('accessToken')).pipe(
    switchMap(async (token) => {
      const accessToken = token as AccessToken;
      if (accessToken?.accessToken) {
        // Okta token found — allow route activation
        return true;
      }

      const isLoggedIn = await authService.isLoggedIn();
      if (isLoggedIn) {
        return true;
      }

      // Save the attempted URL for redirecting after login
      localStorage.setItem('redirectUrl', state.url);
      // Redirect to login
      router.navigate(['/login']);

      return false;
    }),
    catchError(async () => {
      // Fallback: check login on error
      const isLoggedIn = await authService.isLoggedIn();
      if (isLoggedIn) {
        return true;
      }
      return false;
    }),
  );
};
